import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BookingButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isAfterCarePage = location.pathname === '/artist' || location.pathname === '/aftercare';

  const buttonColor = isAfterCarePage
    ? 'z-10 fixed bottom-20 right-4 bg-red-500 text-white py-4 px-4 rounded-full shadow-lg hover:bg-red-600 transition duration-300'
    : 'z-10 fixed bottom-20 right-4 bg-lightBrown text-white py-4 px-4 rounded-full shadow-lg hover:bg-darkBrown transition duration-300';

  const handleBookingClick = () => {
    navigate("/booking");
  };

  return (
    <button className={`${buttonColor} avenir`} onClick={handleBookingClick}>
      Booking
    </button>
  );
};

export default BookingButton;
